import React from 'react';
import Link from '../../Link';
import Spinner from '../../Spinner';
import Tooltip from '../../Tooltip';
import style from './style.module.css';

export default class Button extends React.Component {
    render() {
        const { id = "", display = true, disabledTip = false, className = false, submit = false, label = "", fetching = false, link = "", disabled = false, onClick = () => { }, target = "_self", download = false, buttonType = "button", form = undefined } = this.props;
        let btnClass = `${style.button}${this.getColorClass()}${this.getSizeClass()}${className !== false ? " " + className : ""}`;
        if (display === false) {
            return null;
        }

        if (fetching === true) {
            return (
                <div className={`${btnClass} ${style.fetching}`}>
                    <Spinner color={this.getSpinnerColor()} className={style.spinner} size={window.innerWidth <= 768 ? "tiny" : "small"} />
                </div>
            )
        }

        if (disabled === true) {
            return (
                <div className={`${btnClass} ${style.disabled}`}>
                    <span>{label}</span>
                    {
                        disabledTip !== false && (
                            <>
                                <span className={style.buttonQuestion}>
                                    <i className="fa-solid fa-circle-question"></i>
                                </span>
                                <Tooltip>{disabledTip}</Tooltip>
                            </>
                        )
                    }
                </div>
            )
        }

        if (submit === true) {
            return (
                <button type="submit" className={`${btnClass}`} id={id} form={form}>
                    <span>{label}</span>
                </button>
            )
        }

        return (
            <Link to={link} className={`${btnClass}`} onClick={onClick} target={target} download={download} buttonType={buttonType} id={id}>
                <span dangerouslySetInnerHTML={{ __html: label }}></span>
            </Link>
        )
    }

    getSizeClass = () => {
        const { size } = this.props;
        if (size === "tiny") {
            return " " + style.buttonTiny;
        }
        if (size === "medium") {
            return " " + style.buttonMedium;
        }
        return ""
    }

    getColorClass = () => {
        const { color } = this.props;
        if (color === "secondary") {
            return " " + style.secondary;
        }
        if (color === "orange") {
            return " " + style.orange;
        }
        if (color === "white") {
            return " " + style.white;
        }
        return ""
    }

    getSpinnerColor = () => {
        const { color } = this.props;
        if (color === "secondary") {
            return "var(--secondaryColor)";
        }
        if (color === "white") {
            return "var(--thirdColor)";
        }
        return "var(--secondaryColor)";
    }
}